import Actions from '../constants/Actions';
const TIMEOUT = 2000000;
var cookie = require('react-cookie');

const WebsiteLoadCreator = {

  /* landingpage function*/
  loadWebsiteLanding(context, {id}, done) {
    context.service.read('websitelisting', {
      limit: '3'
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_WEBSITE_SUCCESS, data);
        done();
      }
    );
  },

  loadServices(context, content, done) {
    context.service.read('serviceslisting', {
      limit: '1'
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_SERVICE_SUCCESS, data);
        done();
      }
    );
  },

  loadCategoryServices(context, {id}, done) {
    context.service.read('categoryListing', {
      id: id,
      limit: '100'
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }

        context.dispatch(Actions.LOAD_SERVICE_SUCCESS, data);
        done();
      }
    );
    context.service.read('trendinglist', {}, {
      timeout: TIMEOUT
    },
      (err, list) => {
        if (err) {
          return done(err);
        }

        context.dispatch(Actions.LOAD_CATEGTRENDING_SUCCESS, list);
      }
    );
  },

  loadProducts(context, content, done) {
    context.service.read('productlisting', {
      limit: '3'
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_PRODUCT_SUCCESS, data);
        done();
      }
    );
  },

  /* landingpage load more button function */

  loadMoreWebsites(context, limitob, done) {
    context.service.read('websitelisting', {
      limit: limitob.limit + 7
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_WEBSITE_SUCCESS, data);
        done();
      }
    );
  },
  loadMoreServices(context, limitob, done) {
    context.service.read('serviceslisting', {
      limit: limitob.limit + 30
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_SERVICE_SUCCESS, data);
        done();
      }
    );
  },
  loadMoreProducts(context, limitob, done) {
    context.service.read('productlisting', {
      limit: limitob.limit + 30
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_PRODUCT_SUCCESS, data);
        done();
      }
    );
  },
  loadUserFavourite(context, content, done) {
    context.dispatch(Actions.LOAD_USERFAVOURITE_SUCCESS, data);
    done();
  },
  loadHomeEntity(context, { id } , done){
    context.service.read('userfeedbackservice', { id }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
          //context.dispatch(Actions.LOAD_USERFEEDBACK_SUCCESS, data);

         //  var inputIds = JSON.parse(data[0].OptionIdJson).join(',');
         // console.log("data", inputIds );

          var content = {};
         // var contentdata = data ? JSON.parse(data).join(',') : '';
          content.id = data ? data : '' ;
         //console.log("contentids",content);
          data ? context.service.read('predict', content, {
          timeout: TIMEOUT
        },
          (err, results) => {
            if (err) {
              return done(err);
            }
            context.service.read('userentityservice', results, {
              timeout: TIMEOUT
            },
              (err1, data) => {
                if (err1) {
                  return done(err1);
                }
                var newdata = {
                  inputs: content.ids,
                  data: data
                };
                context.dispatch(Actions.LOAD_USERFEEDBACK_SUCCESS, newdata);
                done();
              }
            );
          }
        ) : '';

        done();
      }
    );
  },
  storeUserSelectedEntity(context, content, done) {
    context.service.update('tempuserpredict', content.ids, null, {
              timeout: TIMEOUT
            },
              (err, results) => {
                if (err) {
                  return done(err);
                }
                //context.dispatch(Actions.LOAD_USERFAVOURITE_SUCCESS, newdata);
                done();
              }
        );
  },
  loadEntertainer(context, content, done) {
    context.service.read('newuser', content, {
      timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return done(err);
        }
        var type = typeof results;
        // console.log("id", JSON.stringify(results));
        // var newtype = typeof JSON.stringify(results);
        // console.log("type", newtype);
        // results = JSON.stringify(results);
        var resultId = results;
        context.service.read('entertainersearchservice', resultId, {
          timeout: TIMEOUT
        },
          (err1, data) => {
            if (err1) {
              return done(err1);
            }
            var newdata = {
              inputs: content.ids,
              data: data
            };
            context.dispatch(Actions.LOAD_USERFAVOURITE_ENTERTAINER_SUCCESS, newdata);
            done();
          }
        );
      }
    );
  },
  loadUserEntity(context, content, done) {
    context.service.read('predict', content.ids, {
      timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return done(err);
        }
        context.service.read('searchservice', results, {
          timeout: TIMEOUT
        },
          (err1, data) => {
            if (err1) {
              return done(err1);
            }
            var newdata = {
              inputs: content.ids,
              data: data
            };

            context.dispatch(Actions.LOAD_USERFAVOURITE_SUCCESS, newdata);
            done();
          }
        );
      }
    );
  },
  UpdateLikeEntertainer(context, content, done){
    context.service.update('entertainerLikeservice', content, null, {
      timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return done(err);
        }
        $(".whirly-loader").css('visibility', 'hidden');
        location.reload();
        done();
      }
    );
  },
  refreshUserEntity(context, content, done) {
    context.dispatch(Actions.REFRESH_USERFAVOURITE, {});
    done()
  },
  updateUserEntityOnFeedback(context, content, done) {
    context.service.update('predict', content, null, {
      // timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return done(err);
        }
        context.service.read('searchservice', results, {
          // timeout: TIMEOUT
        },
          (err1, data) => {
            if (err1) {
              return done(err1);
            }
            context.dispatch(Actions.UPDATE_FEEDBACK_USERFAVOURITE_SUCCESS, {
              results: data,
              index: content.indextoreplacefrom
            });
            done();
          }
        );
      }
    );
  },
  createUserCSV(context, content) {
    content.type = "CSV";
    context.service.create('predict', content.input, null, {
      timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return content.callback(err);
        }
        content.callback(results);
      }
    );
  },
  createUserJSD(context, content) {
        content.type = "JSD";

    context.service.create('predict', content.input, null, {
      timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return content.callback(err);
        }
        content.callback(results);
      }
    );
  },
  flushUserPreference(context, content) {
    context.service.delete('userservice', content.userid, {
      timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return content.callback(err);
        }
        content.callback(results);
      }
    );
  },
  /* entity page function*/
  loadWebsite(context, {id}, done) {
    context.service.read('websiteinfoservice', {
      id
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_ENTITYWEBSITE_SUCCESS, data);
        done();
      }
    );
  },
  loadServicesentity(context, {id}, done) {
    context.service.read('serviceentity', {
      id
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_ENTITYSERVICE_SUCCESS, data);
        done();
      }
    );
    context.service.read('servicetrendinglist', {
      id
    }, {
      timeout: TIMEOUT
    },
      (err, list) => {
        if (err) {
          return done(err);
        }

        context.dispatch(Actions.LOAD_SERVICETRENDING_SUCCESS, list);
      }
    );
  },
  loadAutoComplete(context, content, done) {
    context.service.read('autocompleteservice', content, {
      timeout: TIMEOUT
    },
      (err, results) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_AUTOCOMPLETESERVICE_SUCCESS, results);
        done(null, results);
      }
    );
  },

  loadproductentity(context, {id}, done) {
    context.service.read('productentity', {
      id
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_ENTITYPRODUCT_SUCCESS, data);
        done();
      }
    );
  },
  /* category more function*/
  loadWebsiteEntityFromCategory(context, content, done) {
    context.service.read('loadWebsiteEntityFromCategory', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_WEBSITEMORE_SUCCESS, data);
        done();
      }
    );
  },
  loadServiceEntityFromCategory(context, content, done) {
    context.service.read('loadmorefromcategory', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_SERVICEMORE_SUCCESS, data);
        done();
      }
    );
  },
  loadProductEntityFromCategory(context, content, done) {
    context.service.read('loadmorefromcategory', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_PRODUCTMORE_SUCCESS, data);
        done();
      }
    );
  },
  /*profile page*/
  loadprofileentity(context, content, done) {
    context.service.read('userprofile', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_PROFILE_SUCCESS, data);
        done();
      }
    );
  },
  updateprofileentity(context, content, done) {
    context.service.update('userprofile', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_PROFILE_SUCCESS, data);
        done();
      }
    );
  }
};

export default WebsiteLoadCreator;



// WEBPACK FOOTER //
// ./src/actions/WebsiteLoadCreator.js